import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Notifier",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { addNotification, closeNotification, removeNotification } =
  slice.actions;

reducerRegistry.register("notifier", reducer);
